import { DatePipe, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services';
import { ApiService } from 'src/app/api.service';
import { Item } from 'src/app/shared/models/Item';
import { ItemsAlbum } from 'src/app/shared/models/ItemsAlbum';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { Constants } from 'src/app/shared/vo/Constants';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';

@Component({
  selector: 'app-items-album-list',
  templateUrl: './items-album-list.component.html',
  styleUrls: ['./items-album-list.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class ItemsAlbumListComponent implements OnInit {

  lbl_select: string = "select_";
  lbl_go_Back: string = "back_";
  lbl_new_record: string = "new_record_";
  lbl_item: string = "item_";
  lbl_collections: string = "collections_";
  lbl_id: string = "id_";
  lbl_name: string = "name_";
  lbl_edit: string = "edit_";
  lbl_search: string = "search_";
  lbl_total: string = "total_";
  lbl_delete_record: string = "delete_record_";
  lbl_save: string = "save_";


  location: Location;

  lstItemsAlbum: ItemsAlbum[];
  selectedAlbum: ItemsAlbum;
  itemId: string;
  token: string;
  passKey: string; //Access for purchasing phisical audios
  device: string;
  security: SecurityDocument;
  item: Item = null;
  albumId: string;
  dnwGroup: string;
  name: string;
  itemDialog: boolean;
  showInternatColumns: boolean = false;
  showBackButton: boolean = true;
  selLang: string;

  // Redirect to album 
  itemIdAlbum: string;
  dnwGroupAlbum: string;
  tokenAlbum: string;
  languageAlbum: string;

  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService,
    private authenticationService: AuthenticationService,


  ) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(
        params => {

          this.itemIdAlbum = params.itemId;
          this.dnwGroupAlbum = params.dnwGroup;
          this.tokenAlbum = params.token;
          this.languageAlbum = params.language;

          this.itemId = params.itemId;
          this.token = params.token;
          this.dnwGroup = params.dnwGroup;
          this.selLang = params.language;
          this.passKey = params.passKey;
          this.device = params.device;
        });


    if (this.passKey && this.device == 'USAPP') {
      this.showBackButton = false;
      this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');

    } else {
      this.getSecurity();
    }

  }
  getSecurity() {

    this.apiService.findSecurityById({ "id": this.token }).then(
      data => {
        this.security = data;
        if (this.security) {

          if (this.itemId && !this.passKey) {

            if (this.security.levelId == 'I' && (this.security.functionId == 'secre' || this.security.functionId == 'coord' || this.security.functionId == 'treas' || this.security.functionId == 'mate') || this.security.userId=='administrador') {
              this.showInternatColumns = true;
              this.loadPage();
            } else {
              this.getPurchItmDwnById();
            }

          }


        }
      });

  }
  lstItmsAlbByItemLanguage() {
    this.lstItemsAlbum = null;
    this.apiService.lstItmsAlbByItemLanguage({
      "itemId": this.itemId,
      "language": this.selLang,
      "guideId":this.security.guideId
    }).then(
      data => {
        this.lstItemsAlbum = data;

      });
  }
  eventCancel() {
    this.itemIdAlbum = '';
    this.dnwGroupAlbum = '';
    this.tokenAlbum = '';
    this.languageAlbum = '';

    this.router.navigate(['santov/shop'], { queryParams: { token: this.token, dnwGroup: this.dnwGroup, language: this.selLang, device: this.device } });
  }
  getItemById() {

    this.apiService.getItemByIdLang(
      {
        "itemId": this.itemId,
        "language": this.selLang
      }
    ).then(
      data => {
        this.item = data;
      }).catch(error => {
        console.error(error);
      });
  }
  selectRecord(albumId: string) {
    let widthWin = 1200;
    if (this.security.levelId != 'I') {
      widthWin = 900;
    }

    const queryParams = {
      itemId: this.itemId, albumId: albumId, token: this.token, dnwGroup: this.dnwGroup, language: this.selLang, passKey: this.passKey
    };


    const url1 = this.router.createUrlTree(['santov/itemTracksDwn'], {
      queryParams: queryParams
    });
    let obj = {
      itemId: this.itemId,
      albumId: albumId,
      token: this.token,
      language: this.selLang,
      passKey: this.passKey,
      device: this.device,
      itemIdAlbum: this.itemIdAlbum,
      dnwGroupAlbum: this.dnwGroupAlbum,
      tokenAlbum: this.tokenAlbum,
      languageAlbum: this.languageAlbum
    }

    let navigationExtras: NavigationExtras = {
      queryParams: JSON.parse(JSON.stringify(obj))
    }
    const url = this.router.createUrlTree(['santov/itemTracksDwn'], navigationExtras);

    if (Constants.audioWindow) {
      Constants.audioWindow.close();
    }
    Constants.audioWindow = window.open("#" + url.toString(), "_blank", "resizable=no, titlebar=no,toolbar=no, scrollbars=yes, menubar=no, status=no,statusbar=no, directories=no, location=no, width=" + widthWin + ", height=1000, left=30, top=100 ");

  }
  openNew() {
    this.albumId = null;
    this.name = null;
    this.selectedAlbum = null;
    this.itemDialog = true;
  }
  hideDialog() {
    this.itemDialog = false;
    this.selectedAlbum = null;
    this.lstItmsAlbByItemLanguage();
  }
  createUpdate() {
    if (this.selectedAlbum == null || this.selectedAlbum.id == null) {
      //create


      this.apiService.createItemsAlbum(
        {
          "id": {
            "itemId": this.itemId,
            "language": this.selLang,
            "albumId": this.albumId
          },
          "name": this.name
        }).then(
          data => {
            this.hideDialog();
          }).catch(error => {
            console.error(error);
          });



    } else {
      //update

      this.apiService.updateItemsAlbum(
        {
          "id": {
            "itemId": this.itemId,
            "language": this.selLang,
            "albumId": this.selectedAlbum.id.albumId
          },
          "name": this.name
        }).then(
          data => {
            this.hideDialog();
          }).catch(error => {
            console.error(error);
          });



    }

  }

  edit(doc: ItemsAlbum) {
    this.selectedAlbum = null;
    this.apiService.getItemsAlbumById(
      {
        "itemId": doc.id.itemId,
        "albumId": doc.id.albumId,
        "language": doc.id.language
      }
    ).then(
      data => {
        this.selectedAlbum = data;
        this.name = doc.name;
        this.albumId = doc.id.albumId;
        this.itemDialog = true;

      });

  }
  removeSelected() {

    this.apiService.deleteItemsAlbum(
      {
        "id": {
          "itemId": this.selectedAlbum.id.itemId,
          "albumId": this.selectedAlbum.id.albumId,
          "language": this.selectedAlbum.id.language
        }
      }
    ).then(
      data => {
        this.hideDialog();

      });

  }
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_select, this.lbl_go_Back, this.lbl_new_record, this.lbl_item, this.lbl_collections, this.lbl_id, this.lbl_name, this.lbl_edit, this.lbl_search, this.lbl_total, this.lbl_delete_record, this.lbl_save]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_new_record = map.get(this.lbl_new_record);
        this.lbl_item = map.get(this.lbl_item);
        this.lbl_collections = map.get(this.lbl_collections);
        this.lbl_id = map.get(this.lbl_id);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_edit = map.get(this.lbl_edit);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_delete_record = map.get(this.lbl_delete_record);
        this.lbl_save = map.get(this.lbl_save);
      });
  }
  findPurchItmDwnByPassKey() {
    this.apiService.findPurchItmDwnByPassKey(
      {
        "id": this.passKey,
        "language": this.selLang
      }
    ).then(
      data => {

        if (data && data.status.trim() == 'OK') {

          this.itemId = data.purchItmDwn.id.itemId;
          this.selLang = data.purchItmDwn.id.language;
          this.security = {};
          this.security.language = this.selLang;

          this.loadPage();
        } else {
          this.messageService.add({ severity: 'error', summary: 'ERROR: ' + data.errorMessage, detail: data.errorMessage, life: 10000 });
        }


      });

  }
  getPurchItmDwnById() {
    if (this.security.guideId && this.security.levelId != 'Z') {
      this.apiService.getPurchItmDwnById(
        {
          "itemId": this.itemId,
          "language": this.selLang,
          "guideId": this.security.guideId
        }
      ).then(
        data => {
          this.passKey = data.passKey;
          if (this.passKey) {
            this.findPurchItmDwnByPassKey();
          } else {
            this.loadPage();
          }
        }).catch(error => {
          console.error(error);
          this.loadPage();
        });;
    } else {
      this.loadPage();
    }
  }
  loadPage() {
    this.getTranslatedLabels();
    this.lstItmsAlbByItemLanguage();
    this.getItemById();
  }

  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {

          if (data.code == 'R-0200') {

            this.findPurchItmDwnByPassKey();
          } else {
          }
        },
        error => {
          console.error(error);
        });

  }
}